import { BaseElement } from '@nrk/dh-server-libs/base-element'
import { getElementTag } from '@nrk/dh-server-libs/get-element-tag'
import './client.css'

const tag = getElementTag(__APP_NAME__, __APP_VERSION__)

function safeDefine(elementName, constructor) {
  if (typeof customElements.get(elementName) === 'undefined') {
    customElements.define(elementName, constructor)
  }
}

class AppElement extends BaseElement {
  name = tag
  #observer

  connectedCallback() {
    super.connectedCallback()

    // Log views
    // eslint-disable-next-line compat/compat
    this.#observer = new IntersectionObserver(
      (intersections) => {
        if (intersections[0]?.isIntersecting) {
          this.sendGaEvent({ eventAction: `VIEW` })
          this.#observer.disconnect()
        }
      },
      { threshold: [0.99] },
    )
    this.#observer.observe(this)
  }

  disconnectedCallback() {
    super.disconnectedCallback?.()
    this.#observer?.disconnect()
  }

  render() {
    safeDefine('dh-infosveip', require('./components/infosveip').default)

    this.addEventListener('dh-basis-sveip-active-changed', (e) => {
      e.preventDefault()
      this.sendGaEvent({ eventAction: 'ACTIVE-CHANGED', eventLabel: e.detail.nextIndex })
    })

    this.sendGaEvent({ eventAction: `MOUNT:${tag}` })
  }
}

if (!customElements.get(tag)) {
  customElements.define(tag, AppElement)
}
